module.exports = "<div class=\"preview-note\"><span>Values shown in the template are only examples.</span></div>\n<!--<div class=\"preview-body\" [innerHTML]=\"data.template | htmlBypass\">-->\n<!--</div>-->\n<iframe id=\"email-holder\" class=\"preview-body\" frameborder=\"0\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/template/preview/preview.component.html
// module id = ./src/app/common/template/preview/preview.component.html
// module chunks = main